export default "__VITE_ASSET__CosvCGtR__"